import React from 'react';
import PropTypes from 'prop-types';

// Presentational Component
const ReferenceLink = ({ method, hash }) => {

	const href = `#reference-${method}`;
	const matchClass = hash === href ? 'active-route' : null;

	return (
		<a href={href} className={matchClass}>{`${method}()`}</a>
	);
};

ReferenceLink.propTypes = {
	method: PropTypes.string.isRequired,
	hash: PropTypes.string.isRequired
};

export default ReferenceLink;


// WEBPACK FOOTER //
// ./src/components/javascript-sdk/ReferenceLink.js